export enum Currency {
  AUD = 'AUD',
  PTS = 'PTS',
}
